class DiscountedUpsellsDrag {
  constructor(track) {
    this.track = track;
    this.pointerId = undefined;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.dragged = false;
    this.suppressClick = false;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.endDrag = this.endDrag.bind(this);
    this.onClick = this.onClick.bind(this);

    this.connect();
  }

  connect() {
    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.endDrag);
    this.track.addEventListener('pointercancel', this.endDrag);
    this.track.addEventListener('click', this.onClick, true);
  }

  onPointerDown(event) {
    if (event.pointerType === 'touch' || event.button !== 0) return;

    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
    this.dragged = false;
    this.suppressClick = false;
  }

  onPointerMove(event) {
    if (event.pointerId !== this.pointerId) return;

    const distance = event.clientX - this.startX;

    if (!this.dragged && Math.abs(distance) > 6) {
      this.dragged = true;
      this.suppressClick = true;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture?.(this.pointerId);
    }

    if (this.dragged) {
      this.track.scrollLeft = this.startScrollLeft - distance;
      event.preventDefault();
    }
  }

  endDrag(event) {
    if (event.pointerId !== this.pointerId) return;

    this.track.classList.remove('is-dragging');

    if (this.track.hasPointerCapture?.(this.pointerId)) {
      this.track.releasePointerCapture(this.pointerId);
    }

    this.pointerId = undefined;
    this.dragged = false;
  }

  onClick(event) {
    if (!this.suppressClick) return;

    event.preventDefault();
    event.stopPropagation();
    this.suppressClick = false;
  }
}

const initializeDiscountedUpsellsTracks = (root = document) => {
  root.querySelectorAll('[data-discounted-upsells-track]').forEach((track) => {
    if (track.dataset.dragInitialized === 'true') return;

    track.dataset.dragInitialized = 'true';
    new DiscountedUpsellsDrag(track);
  });
};

initializeDiscountedUpsellsTracks();

document.addEventListener('shopify:section:load', (event) => {
  initializeDiscountedUpsellsTracks(event.target);
});
